import { css, cx } from 'linaria';
const logoDarkImg = 'https://assets.getpocket.com/web-ui/assets/pocket-logo-dark-mode.a24d9ec3c81b642354a61fe27ae9edfb.svg';
const logoLightImg = 'https://assets.getpocket.com/web-ui/assets/pocket-logo-light-mode.9a20614bbcbaf69b221df81a80daa73d.svg';
const logoMarkImg = 'https://assets.getpocket.com/web-ui/assets/pocket-logo-mark.dd8dec213208a4fbf2bff946d112aec3.svg';
const logoStyle = "lduquv9";
const logoMarkStyle = "l1n9llcl";
const logoLabelStyle = "l1m2lm9u";
const Logo = ({
  className
}) => {
  return <div className={cx(logoStyle, className)}>
      <span className={logoLabelStyle}>Pocket</span>
    </div>;
};
const LogoMark = ({
  className
}) => {
  return <div className={cx(logoMarkStyle, className)}>
      <span className={logoLabelStyle}>Pocket</span>
    </div>;
};
export { LogoMark, Logo };

require("./logo.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./logo.js");